import axios from 'axios'

type TGetStackConfigSlim = () => Promise<any>

interface IConfigApi {
    getStackConfigSlim: TGetStackConfigSlim
}

class ConfigApi implements IConfigApi {
    getStackConfig() {
        return axios
            .get(`/config/cfg/stack_config_be`)
            .then(({ data }) => data)
    }
    getStackConfigSlim() {
        return axios
            .get(`/config/cfg/stack_config_be/slim`)
            .then(({ data }) => data)
    }
}

export default new ConfigApi()
